<template>
  <div class="login">
    <div class="login_page">
      <div class="logo_background">
        <img class="logo_img" :src="logo" />
      </div>
      <div class="login_content">
        <input
          v-if="false"
          class="login_input_enterprise_id"
          id="enterprise_id"
          type="text"
          :placeholder="enterpriseId"
        />
        <input
          class="login_input_user_id"
          id="user_id"
          type="text"
          :placeholder="Id"
        />
        <input
          class="login_input_password"
          id="login_password"
          type="password"
          :placeholder="password"
        />
        <input
          type="button"
          class="login_button"
          :value="login"
          @click="loginAction"
        />
      </div>
      <footer>
        <p class="copy_right">
          Copyright &copy; Aiphone Co., Ltd. All rights reserved.
        </p>
        <p class="rev">{{ rev }}</p>
      </footer>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="unauthorized_modal_window" v-if="showUnauthorizedModal">
      <unauthorizedModalWindow @close="closeUnauthorizedModal">
      </unauthorizedModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../masterView/modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../modalWindow/loadingModalWindow.vue'
import unauthorizedModalWindow from '../masterView/modalWindow/unauthorizedModalWindow.vue'

export default {
  data() {
    return {
      logo: require('../../../img/loginLogo.png'),
      enterpriseId: '企業ID',
      Id: 'ユーザID',
      password: 'Password',
      login: 'SIGN IN',
      rev: 'Ver.3.20',
      completeWord: '',
      showCompleteModal: false,
      showloadingModal: false
    }
  },
  computed: {
    showUnauthorizedModal() {
      return this.$store.state.systemAdminDefine.unauthorizedFlag
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  components: {
    completeModalWindow,
    loadingModalWindow,
    unauthorizedModalWindow
  },
  methods: {
    async loginAction() {
      this.showloadingModal = true
      var userId = document.getElementById('user_id').value
      var password = document.getElementById('login_password').value
      if (!this.checkLoginInput(userId, password)) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_100002
        this.completeWord =
          this.sysErrorMsg.MSGCRD0002.name +
          this.sysErrorMsg.MSGCRD0002.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showCompleteModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch('systemAdminDefine/setLoginUser', {userId})
        var response = await this.$store.dispatch(
          'masterSessions/loginMasterUser',
          {userId, password}
        )
        await this.$store.dispatch(
          'systemAdminDefine/successLoginFlag',
          response
        )
        this.$router.push('/master/corporations')
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_100001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0004')
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showCompleteModal = false
    },
    closeUnauthorizedModal(e) {
      this.$store.dispatch('systemAdminDefine/changeUnauthorizedFlag')
    },
    checkLoginInput(userId, password) {
      if (userId === '' || password === '') {
        return false
      }
      return true
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (error.response && error.response.status === 423) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_100003
          this.completeWord =
            this.sysErrorMsg.MSGCRD0121.name +
            this.sysErrorMsg.MSGCRD0121.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          return
        }
        if (!errorMessage.indexOf('MSGCRD')) {
          this.completeWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.completeWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else if (error.response && error.response.data) {
        this.completeWord =
          this.sysErrorMsg.MSGCRD0004.name +
          this.sysErrorMsg.MSGCRD0004.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.completeWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>

<style scoped>
.login {
  background-color: #ddffff;
}
.logo_background {
  background-color: #33ccff;
}
.login_content {
  height: 212px;
  background-color: #bbffff;
}
.login_button {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterLogin/careRingsMasterLogin.vue